import React, { useEffect, useState, useRef, ReactElement } from 'react';
import { Wrapper, Status } from '@googlemaps/react-wrapper';
import { GOOGLE_MAPS_KEY } from '../../../services/constants';
import { FormLabelBox, FormLabel } from '../../Common';

declare const google: any;

interface MapComponentProps {
  center: any;
  zoom: number;
  onChanged: Function;
  disabled: Boolean;

  mapRef: React.MutableRefObject<HTMLInputElement>;
  searchRef: React.MutableRefObject<HTMLInputElement>;
}

function MapComponent(props: MapComponentProps) {
  let map, autocomplete, marker;

  let setLocation = function (location, viewport = null, address = null) {
    marker.setVisible(false);

    if (viewport) {
      map.fitBounds(viewport);
    } else {
      map.setCenter(location);
      map.setZoom(17);
    }

    marker.setPosition(location);
    marker.setVisible(true);

    if (address !== null) {
      props.onChanged(location, address);
    }
  };

  useEffect(() => {
    autocomplete = new google.maps.places.Autocomplete(props.searchRef.current, {
      map: props.mapRef.current,
      fields: ['formatted_address', 'geometry', 'name'],
      mapOptions: { zoom: 15, scrollwheel: false },
    });

    map = new google.maps.Map(props.mapRef.current, {
      mapTypeControl: false,
      disableDefaultUI: props.disabled,
    });

    marker = new google.maps.Marker({
      map,
      anchorPoint: new google.maps.Point(0, -29),
    });

    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      const place = autocomplete.getPlace();

      setLocation(place.geometry.location, place.geometry.viewport, place.formatted_address);
    });

    // Initial position
    if (props.center) {
      setLocation(props.center);
    }
  }, []);

  return (
    <div
      style={{
        height: '250px',
        marginBottom: '15px',
        maxWidth: '450px',
        backgroundColor: '#e5e3df',
      }}
      ref={props.mapRef}
    ></div>
  );
}

function OfferCallAddress(props) {
  const { address, lat, lon } = props.input.value;
  const [status, setStatus] = useState(String);

  const searchRef = React.createRef() as React.MutableRefObject<HTMLInputElement>;
  const mapRef = React.createRef() as React.MutableRefObject<HTMLInputElement>;

  const center = { lat, lng: lon };
  const zoom = 8;

  const onChanged = (location, address) => {
    props.input.value = { address, lat: location.lat(), lon: location.lng() };

    props.onChanged({ address, lat: location.lat(), lon: location.lng() });
  };

  return (
    <Wrapper
      libraries={['places']}
      apiKey={GOOGLE_MAPS_KEY}
      callback={(status) => setStatus(status)}
    >
      <FormLabelBox>
        <FormLabel>ADDRESS</FormLabel>
      </FormLabelBox>

      <input
        name="address"
        disabled={props.disabled}
        defaultValue={address}
        type="text"
        ref={searchRef}
        style={{ width: '300px', marginBottom: '20px', color: 'var(--color-greyish-brown)' }}
      />

      <>
        {status === Status.LOADING || status === Status.FAILURE ? (
          <>Loading map..</>
        ) : (
          <MapComponent
            onChanged={onChanged}
            disabled={props.disabled}
            mapRef={mapRef}
            searchRef={searchRef}
            center={center}
            zoom={zoom}
          />
        )}
      </>
    </Wrapper>
  );
}

export default OfferCallAddress;
